const EQUALS = (a, b) => a === b

const intersect = (a, b, comparator = EQUALS) =>
  a.filter(itemA => b.find(itemB => comparator(itemA, itemB)))

export default intersect
